const Quote = {
    init() {
        document.querySelector('quote form').addEventListener('submit', function (e) {
        e.preventDefault()

        const EMAIL_URL     = "https:\/\/n8n.talsa.com.co\/webhook\/cc6bbfef-5a54-43fe-b9bd-47e6b99b7944";
        const EMAIL_TO      = "info@talsa.com.co";
        const EMAIL_SUBJECT = "Solicitud de cotización";

        const formData = new FormData(this)
        const data = Object.fromEntries(formData.entries())
        const bodyHtml = `
            <h2>Solicitud de información de producto</h2>
            <p><strong>Producto:</strong> ${data.product_name} (ID: ${data.product_id})</p>
            <p><strong>Cliente:</strong> ${data.name}</p>
            <p><strong>Documento:</strong> ${data.id_type.toUpperCase()} ${data.id_number}</p>
            <p><strong>Email:</strong> ${data.email}</p>
            <p><strong>Teléfono:</strong> ${data.phone}</p>
            <p><strong>País:</strong> ${data.country}</p>
            <p><strong>Ciudad:</strong> ${data.city}</p>
            <p><strong>Método de contacto:</strong> ${data.contact_method}</p>
            <p><strong>Mensaje:</strong><br>${data.message}</p>
            `;
        
        fetch(EMAIL_URL, {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                "body": bodyHtml,
                "to": EMAIL_TO,
                "subject": EMAIL_SUBJECT
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
            document.querySelector('.modal-success-message').style.display = 'block'
            document.querySelector('.modal-body').style.display = 'none'
            } else {
            alert('Error al enviar la solicitud. Inténtalo de nuevo más tarde.')
            }
        })
        .catch(error => {
            //console.error('Error:', error)
            alert('Error al enviar la solicitud. Inténtalo de nuevo más tarde.')
        })
        
        })
    }
}
